import * as ACTION_TYPES from "../actions/actionTypes";
import dotProp from "dot-prop-immutable";
import { ItemTypes } from "../constants/staticKeys";

const INITIAL_STATE = {
  staticPlaces: [
    { name: ItemTypes.IHDKH, score: 50 },
    { name: ItemTypes.IH, score: 40 },
    { name: ItemTypes.MZ, score: 40 },
    { name: ItemTypes.MR, score: 10 },
    { name: ItemTypes.MN, score: 10 },
    { name: ItemTypes.MARJ, score: 20 },
    { name: ItemTypes.MMAB, score: 0 },
    { name: ItemTypes.JA, score: 40 },
    { name: ItemTypes.JQ, score: 10 },
    { name: ItemTypes.JZ, score: 1 },
    { name: ItemTypes.JL, score: 10 },
    { name: ItemTypes.JJ, score: 10 },
    { name: ItemTypes.JIBN, score: 5 }
  ],
  plans: [],
  suggestedCombinations: {},
  // suggestedCombinations: {
  //   One: { sunday: {}, monday: {}, tuesday: {}, wednesday: {}, thursday: {}, friday: {}, saturday: {} },
  //   Two: { sunday: {}, monday: {}, tuesday: {}, wednesday: {}, thursday: {}, friday: {}, saturday: {} },
  //   Three: { sunday: {}, monday: {}, tuesday: {}, wednesday: {}, thursday: {}, friday: {}, saturday: {} },
  //   Four: { sunday: {}, monday: {}, tuesday: {}, wednesday: {}, thursday: {}, friday: {}, saturday: {} },
  //   Five: { sunday: {}, monday: {}, tuesday: {}, wednesday: {}, thursday: {}, friday: {}, saturday: {} },
  //   Six: { sunday: {}, monday: {}, tuesday: {}, wednesday: {}, thursday: {}, friday: {}, saturday: {} },
  //   Seven: { sunday: {}, monday: {}, tuesday: {}, wednesday: {}, thursday: {}, friday: {}, saturday: {} }
  // },
  isOpenNewPlanModal: false,
  newPlanName: "",
  zoom: 10,
  isMatrixSaving: false,
  isMasterPlanLoading: false,
  isMasterPlanSaveLoading: false,
  isEfficiencyMatrixLoading: false,
  isEfficiencyMatrixComputeLoading: false,
  isEfficiencyDirty: false
};

export default (state = INITIAL_STATE, action) => {
  const { UPDATE_SHEDULE_BUILDER_PROPS, MERGE_SHEDULE_BUILDER_PROPS, DELETE_SHEDULE_BUILDER_PROPS, CLEAR_STATE } = ACTION_TYPES;
  switch (action.type) {
    case UPDATE_SHEDULE_BUILDER_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.set(newState, action.payload[i].prop, action.payload[i].value);
      }
      return newState;
    }
    case MERGE_SHEDULE_BUILDER_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.merge(newState, action.payload[i].prop, action.payload[i].value);
      }
      return newState;
    }
    case DELETE_SHEDULE_BUILDER_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.delete(newState, action.payload[i].prop);
      }
      return newState;
    }
    case CLEAR_STATE: {
      let newState = state;
      newState = INITIAL_STATE;
      return newState;
    }
    default:
      return state;
  }
};
